import { fetchApi } from "./index";

export interface InterestImage {
  interest: string;
  imageUrl: string;
}

export const addInterestImage = async (
  mentorId: string,
  interest: string,
  file: File,
): Promise<InterestImage[]> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("interest", interest);

  const { data } = await fetchApi<{ interest_images: InterestImage[] }>({
    url: `/v2/users/${mentorId}/interest-image`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data.interest_images;
};

export const removeInterestImage = async (
  mentorId: string,
  interest: string,
  imageUrl: string,
): Promise<InterestImage[]> => {
  const { data } = await fetchApi<{ interest_images: InterestImage[] }>({
    url: `/v2/users/${mentorId}/interest-image`,
    method: "DELETE",
    data: { interest, imageUrl },
  });

  return data.interest_images;
};
